import { createContext } from "react";

export const ClickContext = createContext({});